import './EmptySection.scss'

interface EmptySectionProps {
    title: string;
    description?: string;
    icon?: React.ReactNode
}

const EmptySection = ({ title, description, icon }: EmptySectionProps) => {
    return (
        <div className='empty__section__container'>
            {icon && <div className='empty__section__icon'>{icon}</div>}
            <div className='empty__details__container'>
                <span className='empty__section__title'>{title}</span>
                {description && <p className='empty__section__description'>{description}</p>}
            </div>
        </div>
    )
}

export default EmptySection